import { GetServerSideProps } from 'next';

import { altDomain, primaryDomain } from '../../config';

const Robots = () => null;

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
	const { host } = req.headers;
	const domain = host === altDomain ? altDomain : primaryDomain;

	const robots = `User-agent: *
Disallow:

Sitemap: https://${domain}/sitemap.xml
	`;

	res.setHeader('Content-Type', 'text/plain');
	res.write(robots);
	res.end();

	return {
		props: {},
	};
};

export default Robots;
